import { render, staticRenderFns } from "./prankdetail.vue?vue&type=template&id=06721376&scoped=true&"
import script from "./prankdetail.vue?vue&type=script&lang=js&"
export * from "./prankdetail.vue?vue&type=script&lang=js&"
import style0 from "./prankdetail.vue?vue&type=style&index=0&id=06721376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06721376",
  null
  
)

export default component.exports